import { render, staticRenderFns } from "./MStoreSimpleTable.vue?vue&type=template&id=17d1dc4a&scoped=true&"
import script from "./MStoreSimpleTable.vue?vue&type=script&lang=ts&"
export * from "./MStoreSimpleTable.vue?vue&type=script&lang=ts&"
import style0 from "./MStoreSimpleTable.vue?vue&type=style&index=0&id=17d1dc4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d1dc4a",
  null
  
)

export default component.exports